import * as React from 'react';
import { PrimaryButton } from '@fluentui/react';
import { Maschinenkunde } from 'api/maschinenkunde';
import { defaultSmDate, formatSmDate } from 'utils/formatter';
import { formStyles } from 'styles/formStyles';
import { Timestamps } from 'formComponents/Timestamps';
import nl2br from 'react-nl2br';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { maschinentypenByNrSelector } from 'store/lookups/selector';

interface MaschinenkundeItemProps {
    maschinenkunde: Maschinenkunde;
    editMaschinenkunde: () => void;
}

export const MaschinenkundeItem: React.FC<MaschinenkundeItemProps> = ({ maschinenkunde, editMaschinenkunde }) => {
    const maschinentypenByNr = useSelector(maschinentypenByNrSelector);

    return (
        <div
            className={classnames(formStyles.listItem, {
                [formStyles.listItemArchived]: maschinenkunde.datAusgesch !== defaultSmDate || maschinenkunde.archiv,
            })}
        >
            <div className={formStyles.topBlock}>
                <div>
                    <div className={formStyles.listTitle}>
                        {maschinenkunde.hersteller && maschinenkunde.hersteller + ', '}
                        {maschinenkunde.type && maschinenkunde.type + ' '}
                        {maschinenkunde.baujahr && ' (' + maschinenkunde.baujahr + ') '}
                    </div>
                </div>
                <div className={formStyles.archivedTest}>{maschinenkunde.archiv && '(archiviert)'}</div>
                <div>
                    <PrimaryButton
                        onClick={() => {
                            editMaschinenkunde();
                        }}
                        text="Bearbeiten"
                    />
                </div>
            </div>
            <div className={formStyles.threeColumnsBlock}>
                <div className={formStyles.keyValueLine}>
                    <div className={formStyles.dataKey100}>Hersteller:</div>
                    <div className={formStyles.dataValue}>
                        <strong>{maschinenkunde.hersteller}</strong>
                    </div>
                </div>
                <div className={formStyles.keyValueLine}>
                    <div className={formStyles.dataKey100}>Type:</div>
                    <div className={formStyles.dataValue}>
                        <strong>{maschinenkunde.type}</strong>
                    </div>
                    <div className={formStyles.dataKey100}>Maschinentype:</div>
                    <div className={formStyles.dataValue}>
                        <strong>
                            {maschinenkunde.type
                                ? maschinentypenByNr[maschinenkunde.mtNr]?.name ?? maschinenkunde.mtNr
                                : ''}
                        </strong>
                    </div>
                </div>

                <div className={formStyles.keyValueLine}>
                    <div className={formStyles.dataKey100}>Geräte-Nr:</div>
                    <div className={formStyles.dataValue}>
                        <strong>{maschinenkunde.geraeteNr}</strong>
                    </div>
                    <div className={formStyles.dataKey100}>Artikel-Nr:</div>
                    <div className={formStyles.dataValue}>
                        <strong>{maschinenkunde.artikelNr}</strong>
                    </div>
                </div>
            </div>
            <div className={formStyles.threeColumnsBlock}>
                <div className={formStyles.keyValueLine}>
                    <div className={formStyles.dataKey100}>Baujahr:</div>
                    <div className={formStyles.dataValue}>
                        <strong>{maschinenkunde.baujahr ? maschinenkunde.baujahr : ''}</strong>
                    </div>
                </div>
                <div className={formStyles.keyValueLine}>
                    <div className={formStyles.dataKey100}>Liefer-Datum:</div>
                    <div className={formStyles.dataValue}>
                        <strong>
                            {maschinenkunde.lDat && maschinenkunde.lDat !== defaultSmDate
                                ? formatSmDate(maschinenkunde.lDat, true)
                                : '?'}
                        </strong>
                    </div>
                </div>
                <div className={formStyles.keyValueLine}>
                    <div className={formStyles.dataKey100}>Ausgesch. seit:</div>
                    <div className={formStyles.dataValue}>
                        <strong>
                            {maschinenkunde.lDat && maschinenkunde.datAusgesch !== defaultSmDate
                                ? formatSmDate(maschinenkunde.datAusgesch, true)
                                : '?'}
                        </strong>
                    </div>
                </div>
                <div />
            </div>
            <div className={formStyles.keyValueLine}>
                <div className={formStyles.dataKey100}>Bemerkungen:</div>
                <div className={formStyles.dataValue}>{nl2br(maschinenkunde.bem)}</div>
            </div>

            <Timestamps
                modifiedDate={maschinenkunde.updDat}
                modifiedDecimalTime={maschinenkunde.updUhr}
                modifiedUser={maschinenkunde.updUser}
                showCreated={false}
            />
        </div>
    );
};
